import BaseModel from "lib/model";

export default BaseModel.extend({
    props: {
        _id: "string",
        name: "string",
        available_modules: "array",
        active: {
            type: "boolean",
            required: true,
            default: true,
        },
    },
});
